import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';

const DatasetSelectionInfo = () => (
    <Text>
        <Title>Select a Dataset</Title>
        <Subtitle>
            Each message supports only one dataset. To modify or replace it, all
            existing instances must be deleted.
        </Subtitle>
    </Text>
);

export default DatasetSelectionInfo;

const Text = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(3),
    fontSize: aampeTheme.size.font.default,
    lineHeight: '24px',
    color: aampeTheme.colors.neutral09,
    textAlign: 'center',
});

const Title = styled.div({
    fontSize: aampeTheme.size.font.title,
    fontWeight: 600,
    color: aampeTheme.colors.neutral09,
});

const Subtitle = styled.div({
    fontWeight: 400,
    color: aampeTheme.colors.textAccessibleWG01,
    maxWidth: '440px',
});
